"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestDemoBodySchema = exports.SubmitContactBodySchema = exports.SubmitSupportBodySchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
exports.SubmitSupportBodySchema = (0, core_1.StrictObject)({
    name: typebox_1.Type.String({ minLength: 0, maxLength: 1024 }),
    message: typebox_1.Type.String({ minLength: 0, maxLength: 4096 }),
});
exports.SubmitContactBodySchema = (0, core_1.StrictObject)({
    name: typebox_1.Type.String({ minLength: 0, maxLength: 1024 }),
    email: core_1.EmailSchema,
    message: typebox_1.Type.String({ minLength: 0, maxLength: 4096 }),
});
exports.RequestDemoBodySchema = (0, core_1.StrictObject)({
    name: typebox_1.Type.String({ minLength: 0, maxLength: 1024 }),
    email: core_1.EmailSchema,
    companyName: typebox_1.Type.String({ minLength: 0, maxLength: 1024 }),
    appName: typebox_1.Type.String({ minLength: 0, maxLength: 1024 }),
    duration: typebox_1.Type.Integer({ minimum: 15, maximum: 90 }),
    at: core_1.TimestampSchema,
});
